import { useTheme } from '@mui/material';

const CardStyle = () => {
  const theme = useTheme();
  return {
    cardContainer: {
      height: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '18px 14px 17px',
      borderRadius: '16px',
      backgroundColor: '#F4F4F4',
      boxShadow:
        '10px -10px 30px #FFFFFF, 10px 10px 30px rgba(174, 174, 192, 0.4)',
      [theme.breakpoints.up('md')]: {
        height: '150px'
        // width: '518px',
      }
    },
    center: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    rectangle: {
      width: '18px',
      height: '4px',
      margin: '2px 2px 26px',
      backgroundColor: 'var(--light-gray-3)'
    },
    reason: {
      fontSize: '12px',
      fontFamily: 'dana-bold',
      color: 'var(--purply)',
      textAlign: 'right',
      [theme.breakpoints.up('md')]: {
        fontSize: '20px'
      }
    },
    meal: {
      textAlign: 'right',
      objectFit: 'contain',
      paddingRight: '7px'
    },
    sugarNumber: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      fontSize: '24px',
      fontFamily: 'dana-bold',
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        fontSize: '28px'
      }
    },
    sugarUnit: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      fontSize: '14px',
      fontWeight: '400',
      textAlign: 'center'
    },
    date: {
      fontSize: '12px',
      fontFamily: 'dana-bold',
      textAlign: 'left',
      color: '#3CC0C3',
      letterSpacing: '1px',
      [theme.breakpoints.up('md')]: {
        fontSize: '20px'
      }
    },
    clock: {
      display: 'flex',
      justifyContent: 'end',
      direction: 'rtl',

      fontSize: '20px',
      fontWeight: '400',
      letterSpacing: '1px',
      textAlign: 'center',
      color: '#3CC0C3',
      [theme.breakpoints.up('md')]: {
        fontSize: '24px'
      }
    },
    secondRowContainer: {
      display: 'flex',
      alignItems: 'end'
    },
    fiberStyle: {
      width: '8px',
      height: '8px',
      marginLeft: '6px !important'
    }
  };
};

export default CardStyle;
